import { logger, WebStorageAdapter } from '@inboundx/shared/platform';
import { getConfig } from '../config';

/**
 * Custom storage adapter that includes API key configuration
 */
export class ConfigurableStorageAdapter extends WebStorageAdapter {
    private getCurrentApiUrl?: () => string;

    constructor(getCurrentApiUrl?: () => string) {
        super();
        this.getCurrentApiUrl = getCurrentApiUrl;
    }

    async get(keys: string[]): Promise<Record<string, unknown>> {
        // Get base configuration from parent
        const baseConfig = (await super.get(keys)) as Record<string, unknown>;

        // Get our app configuration
        const appConfig = getConfig();

        // Override with our configuration
        const result = { ...baseConfig };

        // Add API key if configured
        if (appConfig.apiKey && keys.includes('inboundx_api_key')) {
            result.inboundx_api_key = appConfig.apiKey;
        }

        // Add API endpoint - prioritize context over old config
        if (keys.includes('api_endpoint')) {
            let currentApiUrl = '';

            if (this.getCurrentApiUrl) {
                try {
                    currentApiUrl = this.getCurrentApiUrl();
                    logger.debug(
                        'ConfigurableStorageAdapter: Using context API URL:',
                        currentApiUrl
                    );
                } catch (error) {
                    console.warn('ConfigurableStorageAdapter: Context function failed:', error);
                    currentApiUrl = '';
                }
            }

            // Use context URL if available and not empty, otherwise fallback to app config
            if (currentApiUrl) {
                result.api_endpoint = currentApiUrl;
            } else if (appConfig.apiUrl) {
                logger.debug(
                    'ConfigurableStorageAdapter: Using app config API URL:',
                    appConfig.apiUrl
                );
                result.api_endpoint = appConfig.apiUrl;
            }
        }

        return result;
    }

    // Convenience method for removing individual items
    async removeItem(key: string): Promise<void> {
        return this.remove([key]);
    }
}
